import { v4 as uuidV4 } from "uuid";

import {
  MatrixTableEffect,
  MatrixTableField,
  DecisionTableOperators,
  MatrixTablePredicate,
} from "src/clients/flow-api/api";

export const getDefaultField = (): MatrixTableField => ({
  id: uuidV4(),
  value: "",
});

export const getDefaultPredicate = (): MatrixTablePredicate => ({
  id: uuidV4(),
  value: "",
  operator: DecisionTableOperators.EQ,
});

export const getDefaultEffect = (): MatrixTableEffect => ({
  id: uuidV4(),
  value: "",
});
